import CopyBlock from "../copyBlock/CopyBlock";
import React, {useEffect, useState} from "react";
import {levelOptions} from '../../config/constant';
import TextExpand from "../textExpand/TextExpand";
import {generateClassName, getEllipsisText, ObjTest} from "jzfz-web-utils";
import SimpleSlider from "../simpleSlider/SimpleSlider";
import ImageViewer from "../imageViewer/ImageViewer";
import {QuestionTypeEnum} from '../../config/constant';
import {Button, Checkbox, Form, message, Radio} from "antd";
import style from "./style/section";
import './style/section.less';
import {CustomerTypeEnum} from "../../config/constant";


const iconQuestionStyle = {backgroundImage: `url(${require('../../assets/images/icon-question.png')})`};
const iconMedalStyle = {backgroundImage: `url(${require('../../assets/images/icon-medal.png')})`};
const iconImgStyle = {backgroundImage: `url(${require('../../assets/images/icon-img.png')})`};
const iconBookStyle = {backgroundImage: `url(${require('../../assets/images/icon-book.png')})`};
const iconMainStyle = {backgroundImage: `url(${require('../../assets/images/icon-main.png')})`};
const iconPage3Style = {backgroundImage: `url(${require('../../assets/images/icon-page3.png')})`};


const SectionWrapper = (props: {withInnerStyle?, children}) => {
    const { children, withInnerStyle } = props;
    return (
        <>
            {children}
            { withInnerStyle && <style>{style}</style> }
        </>
    )
}


interface SectionProps {
    withInnerStyle?: boolean;    // 是否携带内联样式标签
    defaultExpandAll?: boolean; // 默认展开所有
    data: any;  // 知识内容
}


interface StandardSection extends SectionProps {
    standardPkid?: string;  // 当前国家规范的pkid
}



/**
 * 国家规范
 * @param props
 * @constructor
 */
export const StandardSection = (props: StandardSection) => {
    const { withInnerStyle, data, standardPkid } = props;


    /**
     * 判断该规范是否是指南型规范
     */
    const isGuide = (): boolean => {
        return data.belongStandardId && data.belongStandardId === standardPkid;
    }


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <div className={generateClassName(['national-standard-section-wrap', isGuide() ? 'standard-guide' : ''])}>
                    <div className="national-standard-section-top">
                        {
                            isGuide() ? null : (
                                <div>
                                    <div className="common-section-sub-title">
                                        <i className="icon-main" style={iconMainStyle}></i>条文正文
                                    </div>
                                    <CopyBlock
                                        className={generateClassName([
                                            'standard-content-html tinymce-content',
                                            data.isArticle === 1 ? 'standard-content-bold' : '',
                                        ])}
                                        dangerouslySetInnerHTML={{__html: data.articleText}}
                                    />
                                </div>
                            )
                        }
                        <div>
                            <div className="common-section-sub-title">
                                <i className="icon-page3" style={iconPage3Style}></i>条文说明
                            </div>
                            <CopyBlock
                                className="standard-content-html tinymce-content"
                                dangerouslySetInnerHTML={{__html: data.articleDesc}}
                            />
                        </div>
                    </div>
                    {
                        data.articleInterpretation ? (
                            <div className="national-standard-section-bottom">
                                <div className="common-section-sub-title">
                                    <i className="icon-book" style={iconBookStyle}></i>条文解读
                                </div>
                                <CopyBlock
                                    className="tinymce-content"
                                    dangerouslySetInnerHTML={{__html: data.articleInterpretation}}
                                />
                            </div>
                        ) : null
                    }
                </div>
            </ImageViewer>
        </SectionWrapper>
    )
}


/**
 * 典型问题
 * @param props withInnerStyle: 是否带内联样式标签 defaultExpandAll:默认是否展开全部
 * @constructor
 */
export const TypicalProblemSection = (props: SectionProps) => {
    const { withInnerStyle, defaultExpandAll, data } = props;
    // 查看全部
    const [textExpand, setTextExpand] = useState<boolean>(false);


    useEffect(() => {
        return () => {
            setTextExpand(false);
        }
    }, [data])


    /**
     * 获取问题等级标签
     * @param level
     */
    const getLevelLabel = (data: any): React.ReactNode => {
        const { problemLevel, isStrongBar } = data;
        let level = isStrongBar ? 5 : problemLevel;
        let target = levelOptions.find((v: any) => v.value === level);
        if (!target) {
            return null;
        }
        return <span className={['level-label', `level-label${level}`, ``].join(' ')}>{target.label}</span>
    }


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <div className={['typical-problem-section-wrap', !defaultExpandAll ? (textExpand ? '' : 'typical-problem-section-full') : ''].join(' ')} >
                <div>
                    <div className="common-section-sub-title">
                        <i className="icon-question" style={iconQuestionStyle}></i>问题描述
                        { getLevelLabel(data) }
                        {
                            (data.tags || []).map((v: any, i: number) => (
                                <span className="content-title-label" key={i}>{v}</span>
                            ))
                        }
                    </div>
                    <CopyBlock className="common-section-sub-content">
                        {
                            defaultExpandAll ? (
                                <div>
                                    { (data.areaPhaseTags || []).map((v: any, i: number) => (
                                        <span className="content-inner-label" title={v} key={i}>{getEllipsisText(v, 25)}</span>
                                    )) }
                                    {data.description}
                                </div>
                            ) : (
                                <TextExpand
                                    content={data.description}
                                    contentRender={(text: string, handler: React.ReactNode) => (
                                        <>
                                            { (data.areaPhaseTags || []).map((v: any, i: number) => (
                                                <span className="content-inner-label" title={v} key={i}>{getEllipsisText(v, 25)}</span>
                                            )) }
                                            {text}{handler}
                                        </>
                                    )}
                                    onExpand={(expanded: boolean) => setTextExpand(expanded)}
                                />
                            )
                        }
                    </CopyBlock>
                </div>
                <div>
                    <div className="common-section-sub-title">
                        <i className="icon-medal" style={iconMedalStyle}></i>解决措施
                    </div>
                    <CopyBlock className="common-section-sub-content">
                        <TextExpand
                            content={data.solution}
                            contentRender={(text: string, handler: React.ReactNode) => (
                                <>{text}{handler}</>
                            )}
                            onExpand={(expanded: boolean) => setTextExpand(expanded)}
                        />
                    </CopyBlock>
                </div>
                {
                    ObjTest.isNotEmptyArray(data.images) ? (
                        <SimpleSlider
                            dataSource={data.images.map(v => v.url)}
                            thumbnailRender={(index: number, slideToIndex: (index: number) => void) => {
                                const { desc } = (data.images || [])[index] || {};
                                return (
                                    <div className="slider-item">
                                        <div className="common-section-sub-title">
                                            <i className="icon-img" style={iconImgStyle}></i>图示
                                        </div>
                                        <div
                                            className="slider-item-describe"
                                            title={desc}
                                        >{desc}
                                        </div>
                                        <div className="thum-img-group">
                                            {
                                                (data.images || []).map((item: any, j: number) => (
                                                    <img
                                                        className={['thum-img', index === j ? 'active' : ''].join(' ')}
                                                        key={j}
                                                        src={item.url}
                                                        onClick={() => slideToIndex(j)}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }}
                            containerRender={(img: any) => (
                                <ImageViewer className="image-viewer">
                                    <CopyBlock className="copy-block">{img}</CopyBlock>
                                </ImageViewer>
                            )}
                        />
                    ) : null
                }
            </div>
        </SectionWrapper>
    )
}


/**
 * 规定问题
 * @param props
 * @constructor
 */
export const RulesProblemSection = (props: SectionProps) => {
    const { withInnerStyle, data }= props;


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <div className="rule-problem-section-wrap">
                    {
                        data.customerType === CustomerTypeEnum.COOPERATE_KEY_POINT && (
                            <div className="rule-problem-cooperation-info">
                                {
                                    ObjTest.isNotEmptyArray(data.responsibilityMajorNames) && (
                                        <div className="rule-problem-cooperation-info-item">
                                            <span className="info-title">责任专业</span>
                                            {
                                                data.responsibilityMajorNames.map((v: string, i: number) => (
                                                    <span className="info-item" key={i}>{(v || '')[0]}</span>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                                {
                                    ObjTest.isNotEmptyArray(data.cooperateMajorNames) && (
                                        <div className="rule-problem-cooperation-info-item">
                                            <span className="info-title">配合专业</span>
                                            {
                                                data.cooperateMajorNames.map((v: string, i: number) => (
                                                    <span className="info-item" key={i}>{(v || '')[0]}</span>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                                {
                                    ObjTest.isNotEmptyArray(data.knowledgeKeyPointNames) && (
                                        <div className="rule-problem-cooperation-info-item">
                                            <span className="info-title">知识要点</span>
                                            {
                                                data.knowledgeKeyPointNames.map((v: string, i: number) => (
                                                    <span className="info-item" key={i}>{v}</span>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    <div className="common-section-sub-content">
                        <CopyBlock>{data.content}</CopyBlock>
                    </div>
                    {
                        data.description ? (
                            <>
                                <div className="common-section-sub-title">
                                    {
                                        data.customerType === CustomerTypeEnum.COOPERATE_KEY_POINT ? (
                                            <>
                                                <i className="icon-img" style={iconPage3Style}></i>说明：
                                            </>
                                        ) : (
                                            <>
                                                <i className="icon-img" style={iconImgStyle}></i>图示：
                                            </>
                                        )
                                    }
                                </div>
                                <CopyBlock
                                    className="tinymce-content common-section-sub-content"
                                    dangerouslySetInnerHTML={{__html: data.description}}
                                />
                            </>
                        ) : null
                    }
                    {
                        ObjTest.isNotEmptyArray(data.attentions) ? (
                            <>
                                <div className="common-section-sub-title">
                                    <i className="icon-medal" style={iconMedalStyle}></i>注意事项：
                                </div>
                                {
                                    data.attentions.map((v: any, i: number) => (
                                        <div key={i}>
                                            <CopyBlock
                                                className="tinymce-content common-section-sub-content"
                                                dangerouslySetInnerHTML={{__html: v}}
                                            />
                                        </div>
                                    ))
                                }
                            </>
                        ) : null
                    }
                    {
                        data.expand ? (
                            <>
                                <div className="common-section-sub-title">
                                    <i className="icon-question" style={iconQuestionStyle}></i>知识拓展：
                                </div>
                                <CopyBlock
                                    className="tinymce-content common-section-sub-content"
                                    dangerouslySetInnerHTML={{__html: data.expand}}
                                />
                            </>
                        ) : null
                    }
                </div>
            </ImageViewer>
        </SectionWrapper>
    )
}


/**
 * 学习资料
 * @param props
 * @constructor
 */
export const LearnDataSection = (props: SectionProps) => {
    const { withInnerStyle, data } = props;


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <div className="common-knowledge-section-wrap learn-data-section-wrap">
                    <div className="common-section-sub-content">
                        <CopyBlock>{data.title}</CopyBlock>
                    </div>
                    {
                        data.content ? (
                            <>
                                <div className="common-section-sub-title">
                                    <i className="icon-question" style={iconQuestionStyle}></i>正文内容：
                                </div>
                                <div>
                                    <CopyBlock
                                        className="tinymce-content common-section-sub-content"
                                        dangerouslySetInnerHTML={{__html: data.content}}
                                    />
                                </div>
                            </>
                        ) : null
                    }
                </div>
            </ImageViewer>
        </SectionWrapper>
    )
}


/**
 * 标准任务
 * @param props
 * @constructor
 */
export const StandardTaskSection = (props: SectionProps) => {
    const { withInnerStyle, data } = props;


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <div className="standard-task-section-wrap">
                    {
                        ObjTest.isNotEmptyArray(data.checkItems) ? (
                            <>
                                <div className="common-section-sub-title">
                                    <i className="icon-question" style={iconQuestionStyle}></i>确认清单：
                                </div>
                                <div
                                    className="common-section-sub-content"
                                    style={{color: '#999'}}
                                >在任务平台提交该标准任务时需逐条确认以下内容
                                </div>
                                {
                                    data.checkItems.map((item: any, j: number) => (
                                        <div key={j} className="common-section-sub-content">
                                            <CopyBlock>{item}</CopyBlock>
                                        </div>
                                    ))
                                }
                            </>
                        ) : null
                    }
                    {
                        ObjTest.isNotEmptyArray(data.descriptions) ? (
                            <>
                                <div className="common-section-sub-title">
                                    <i className="icon-medal" style={iconMedalStyle}></i>任务解读：
                                </div>
                                {
                                    data.descriptions.map((item: any, j: number) => (
                                        <div key={j}>
                                            <CopyBlock
                                                key={j}
                                                className="tinymce-content common-section-sub-content"
                                                dangerouslySetInnerHTML={{__html: item}}
                                            />
                                        </div>
                                    ))
                                }
                            </>
                        ) : null
                    }
                </div>
            </ImageViewer>
        </SectionWrapper>
    )
}


/**
 * 标准图集
 * @param props
 * @constructor
 */
export const StandardMapSection = (props: SectionProps) => {
    const { withInnerStyle, data } = props;


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <div className="common-knowledge-section-wrap standard-map-section-wrap">
                    {
                        ObjTest.isNotEmptyArray(data.mapUrl) ? (
                            data.mapUrl.map((item: any, j: number) => (
                                <div key={j} className="common-section-sub-content">
                                    <CopyBlock>
                                        <img className="w" src={item} />
                                    </CopyBlock>
                                </div>
                            ))
                        ) : null
                    }
                    <div className="common-section-sub-title">
                        <i className="icon-book" style={iconBookStyle}></i>图集解读：
                    </div>
                    <div>
                        <CopyBlock
                            className="tinymce-content common-section-sub-content"
                            dangerouslySetInnerHTML={{__html: data.mapDescription}}
                        />
                    </div>
                </div>
            </ImageViewer>
        </SectionWrapper>
    )
}


/**
 * 自测题目
 * @param props
 * @constructor
 */
export const ExamSection = (props: SectionProps) => {
    const { withInnerStyle, data } = props;
    const { content, type, answerOptions, analysis } = data;
    // 回答结果 0:未答题 1:回答正确 2:回答错误
    const [result, setResult] = useState<number>(0);
    // 表单
    const [form] = Form.useForm();
    const { getFieldsValue, getFieldValue, resetFields } = form;


    useEffect(() => {
        return () => {
            setResult(0);
            resetFields();
        }
    }, [data])


    /**
     * 获取正确答案
     */
    const getCorrectCodes = (): string[] => {
        return answerOptions.filter((v: any) => v.isAnswer).map((v: any) => v.code);
    }


    /**
     * 提交答案
     * @param data
     * @param index
     */
    const examQuestionSubmit = () => {
        const { code } = getFieldsValue();

        if (type === QuestionTypeEnum.MULTIPLE_ANSWER) {
            if (!ObjTest.isNotEmptyArray(code)) {
                message.warn('请先选择选项');
                return;
            }
        }else {
            if (!code) {
                message.warn('请先选择选项');
                return;
            }
        }

        // 用户提交的答案
        let answer = type === QuestionTypeEnum.MULTIPLE_ANSWER ? code : [code];
        // 正确答案
        let codes = answerOptions.filter((v: any) => v.isAnswer).map((v: any) => v.code);
        // 判断回答是否正确
        let flag = answer.every((v: string) => codes.includes(v)) && answer.length === codes.length;
        setResult(flag ? 1 : 2);
    }


    return (
        <SectionWrapper withInnerStyle={withInnerStyle}>
            <ImageViewer>
                <Form className="common-knowledge-section-wrap user-exam-section-wrap" name="connectExamForm" form={form}>
                    <div>
                        <div className="common-section-sub-content">
                            <CopyBlock dangerouslySetInnerHTML={{__html: content}} />
                        </div>
                        <div className="common-section-sub-title pl38">
                            <i className="icon-question" style={iconQuestionStyle}></i>
                            {
                                type === QuestionTypeEnum.TURE_FALSE
                                    ? '判断题,请选择正确答案'
                                    : (type === QuestionTypeEnum.SINGLE_ANSWER ? '单选题,请选择正确答案' : '多选题,请至少选择两个正确答案')
                            }
                        </div>
                        <div className="common-section-sub-content" style={{paddingLeft: 62}}>
                            {
                                type === QuestionTypeEnum.TURE_FALSE || type === QuestionTypeEnum.SINGLE_ANSWER ? (
                                    <Form.Item name="code" noStyle>
                                        <Radio.Group className="db" disabled={result !== 0}>
                                            {
                                                (answerOptions || []).map((item: any, j: number) => (
                                                    <p className="answer-item" key={j}>
                                                        <Radio className="custom-radio-wrapper" value={item.code}>
                                                            <span>{item.code}、</span>
                                                            <span dangerouslySetInnerHTML={{__html: item.content}}></span>
                                                        </Radio>
                                                    </p>
                                                ))
                                            }
                                        </Radio.Group>
                                    </Form.Item>
                                ) : (
                                    <Form.Item name="code" noStyle>
                                        <Checkbox.Group className="db" disabled={result !== 0}>
                                            {
                                                (answerOptions || []).map((item: any, j: number) => (
                                                    <p className="answer-item" key={j}>
                                                        <Checkbox className="custom-checkbox-wrapper" value={item.code}>
                                                            <span>{item.code}、</span>
                                                            <span dangerouslySetInnerHTML={{__html: item.content}}></span>
                                                        </Checkbox>
                                                    </p>
                                                ))
                                            }
                                        </Checkbox.Group>
                                    </Form.Item>
                                )
                            }
                        </div>
                        <div className="common-section-sub-content" style={{paddingLeft: 62}}>
                            {
                                result === 0 ? (
                                    <Button
                                        className="submit-btn"
                                        size="small"
                                        type="primary"
                                        onClick={examQuestionSubmit}
                                    >确认</Button>
                                ) : (
                                    result === 1 ? (
                                        <div className="answer-result">
                                            <span className="correct-tips">回答正确</span>
                                            <span>正确答案: {getCorrectCodes().join('、')}</span>
                                        </div>
                                    ) : (
                                        <div className="answer-result">
                                            <span className="error-tips">回答错误</span>
                                            <span>正确答案: {getCorrectCodes().join('、')}</span>
                                            <span>你的答案: {type === QuestionTypeEnum.MULTIPLE_ANSWER ? getFieldValue('code').join('、') : getFieldValue('code')}</span>
                                        </div>
                                    )
                                )
                            }
                        </div>
                        {
                            [1, 2].includes(result) && (
                                <>
                                    <div className="common-section-sub-title pl38">
                                        <i className="icon-book" style={iconBookStyle}></i>答案解析
                                    </div>
                                    <div className="common-section-sub-content" style={{paddingLeft: 62}} dangerouslySetInnerHTML={{__html: analysis}}></div>
                                </>
                            )
                        }
                    </div>
                </Form>
            </ImageViewer>
        </SectionWrapper>
    )
}
